import React from 'react';
import { Info } from 'lucide-react';
import { typeLegendEntries, typeLegendTitle } from './tripType';

/** Iter 853: «Forklaring Type»-boks ved Type-kolonnen — viser kun kodene som forekommer (NO/EN etter `lang`). */
export function TypeLegend({ codes, lang, className = '', testId = 'type-legend' }: { codes: Iterable<string>; lang: string; className?: string; testId?: string }) {
  const entries = typeLegendEntries(codes, lang);
  if (!entries.length) return null;
  return (
    <div className={`flex flex-wrap items-center gap-x-3 gap-y-1 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600 ${className}`} data-testid={testId}>
      <span className="inline-flex items-center gap-1 font-semibold text-slate-700"><Info className="h-3.5 w-3.5 text-slate-400" />{typeLegendTitle(lang)}:</span>
      {entries.map((e) => (
        <span key={e.code} data-testid={`${testId}-${e.code}`}><b className="font-mono text-slate-800">{e.code}</b> = {e.label}</span>
      ))}
    </div>
  );
}
